module.exports = __webpack_public_path__ + "static/media/Portrait-10247.9832e35a.jpg";